// Compact counts for chart axes: 1.5M, 750K, 12K, 900. Axis labels only —
// tooltips and tables keep the exact figure, since that is where someone
// reads a number rather than a scale.
const compact = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 1,
})

export function formatCompact(n: number): string {
  return compact.format(n)
}
